import { render, staticRenderFns } from "./ViewAutoMvForm.vue?vue&type=template&id=c27bd484&"
import script from "./ViewAutoMvForm.vue?vue&type=script&lang=js&"
export * from "./ViewAutoMvForm.vue?vue&type=script&lang=js&"
import style0 from "./ViewAutoMvForm.vue?vue&type=style&index=0&id=c27bd484&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports